

















import { Component, mixins } from 'nuxt-property-decorator'

import PageTransitionMixin from '@/mixins/transitions/page'

const CATALOGUE_FILENAME = 'LOEWE_INTERNATIONAL_CRAFT_PRIZE_CATALOGUE_2022.pdf'

@Component
export default class PageCatalogue extends mixins(PageTransitionMixin) {
  catalogueLink = `/assets/files/${CATALOGUE_FILENAME}`

  head() {
    const title = this.$t('catalogue.meta_title')
    const description = this.$t('catalogue.meta_description')

    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'og:description', property: 'og:description', content: description },
        // Twitter Card
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid: 'twitter:description', name: 'twitter:description', content: description }
      ]
    }
  }

  beforeMount() {
    this.$store.commit('setLoaded', false)
  }

  onGLLoaded() {
    this.$store.commit('setLoaded', true)
  }

  onFormSuccess() {
    // trigger PDF download
    const filename = `${this.$t('catalogue.filename')}.pdf`

    const a = document.createElement('a')
    a.href = this.catalogueLink
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
